import { render, staticRenderFns } from "./addConvNameModal.vue?vue&type=template&id=5bb147d2&scoped=true"
import script from "./addConvNameModal.vue?vue&type=script&lang=js"
export * from "./addConvNameModal.vue?vue&type=script&lang=js"
import style0 from "./addConvNameModal.vue?vue&type=style&index=0&id=5bb147d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb147d2",
  null
  
)

export default component.exports